$( ->
  $('#job_status_input input').on 'change', ->
    return unless $(this).is(':checked') &&
      $('#job_status_input').data('active') != $('#job_status_input').data('original')

    if $(this).val() == $('#job_status_input').data('active')
      $('#job_post_later_wrapper').collapse('show')
    else
      $('#job_post_later_wrapper').collapse('hide')

  $(document).on 'show.bs.modal', '.activate-job-modal', ->
    if $(this).find('.collapsed-trigger-activate_at').is(':checked')
      $(this).find('.post-job').prop('disabled', true)
    else
      $(this).find('.post-job').prop('disabled', false)
  $(document).on 'hidden.bs.collapse', '.collapsed-target-activate_at', ->
    the_input = $(this).find('input')
    the_input.data('saved-value', the_input.val())
    the_input.val('')
    $(this).closest('.modal-body').find('.post-job').prop('disabled', false)
  $(document).on 'show.bs.collapse', '.collapsed-target-activate_at', ->
    the_input = $(this).find('input')
    if the_input.val() == ''
      if the_input.data('saved-value')?
        the_input.val(the_input.data('saved-value'))
      else
        the_input.val(the_input.data('default'))
    $(this).closest('.modal-body').find('.post-job').prop('disabled', true)

  $(document).on 'submit', '.job-reactivate-form', ->
    val = $(this).closest('.modal-body').find('.collapsed-target-activate_at input').val()
    $(this).find('.job-form-activate_at').val(val)
    true
)
